import { Check, X, Minus } from "lucide-react";
import { Badge } from "../ui/badge";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

interface BooleanBadgeProps {
  value?: boolean | null;
  trueLabel?: string;
  falseLabel?: string;
  variant?: "badge" | "icon";
  showFalse?: boolean;
}

export function BooleanBadge({
  value,
  trueLabel = "Sim",
  falseLabel = "Não",
  variant = "icon",
  showFalse = true,
}: BooleanBadgeProps) {
  const isTrue = !!value;

  if (!isTrue && !showFalse) {
    return <span className="text-muted-foreground">-</span>;
  }

  if (variant === "badge") {
    return (
      <Badge
        variant={isTrue ? "default" : "secondary"}
        className={cn(
          // Base transition
          "font-medium transition-colors",

          isTrue
            ? [
                // Light Mode: Verde Sólido
                "bg-emerald-600 text-white hover:bg-emerald-700",
                // Dark Mode: Verde Translúcido (Glass)
                "dark:border dark:border-emerald-500/20 dark:bg-emerald-500/15 dark:text-emerald-300 dark:hover:bg-emerald-500/25",
              ]
            : [
                // Light Mode: Cinza Sólido (Muted)
                "bg-muted text-muted-foreground hover:bg-muted/80",
                // Dark Mode: Mantém muted, mas ajusta se necessário
                "dark:bg-muted dark:text-muted-foreground",
              ],
        )}
      >
        {isTrue ? trueLabel : falseLabel}
      </Badge>
    );
  }

  // Variant 'icon'
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <div className="flex h-6 w-6 items-center justify-center">
            {isTrue ? (
              // MUDANÇA: text-green-600 -> dark:text-emerald-400 (Mais claro no escuro para contraste)
              <Check className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
            ) : (
              // MUDANÇA: text-slate-400 -> text-muted-foreground (Semântico)
              <X className="h-5 w-5 text-muted-foreground/50" />
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>{isTrue ? trueLabel : falseLabel}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
